import LatestProductSection from "../components/home-page/LatestProductSection";

export default function HomePage() {
  return (
    <>
      <div className="mx-auto flex w-full max-w-7xl flex-col p-10">
        <LatestProductSection />
      </div>
    </>
  );
}
